import React from 'react';

import { HistoryTransforms } from '@aline/common';
import { AlineTooltip, ToolbarButton } from 'src/components';
import { RedoIcon } from 'src/components/icons/RedoIcon';
import { UndoIcon } from 'src/components/icons/UndoIcon';
import { ClientTransforms } from 'src/editor/transforms';
import { useEditor, useEditorLoading } from 'src/layout-engine';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  button: {
    height: 32,
    margin: '0px 2px 0px 2px',
    width: 32,
  },
  wrapper: {
    display: 'flex',
  },
});

export const UndoRedoButtons = React.memo(function UndoRedoButtons(): JSX.Element {
  const editor = useEditor();
  const editorLoading = useEditorLoading();
  const { classes } = useStyles();

  function handleUndo(): void {
    HistoryTransforms.undo(editor);
    ClientTransforms.focus(editor);
  }

  function handleRedo(): void {
    HistoryTransforms.redo(editor);
    ClientTransforms.focus(editor);
  }

  return (
    <div className={classes.wrapper}>
      <AlineTooltip arrow placement="bottom" title="Undo">
        <div>
          <ToolbarButton
            aria-label="Undo"
            className={classes.button}
            disabled={editorLoading}
            onClick={handleUndo}
          >
            <UndoIcon />
          </ToolbarButton>
        </div>
      </AlineTooltip>
      <AlineTooltip arrow placement="bottom" title="Redo">
        <div>
          <ToolbarButton
            className={classes.button}
            data-cy="redo-button"
            disabled={editorLoading}
            onClick={handleRedo}
          >
            <RedoIcon />
          </ToolbarButton>
        </div>
      </AlineTooltip>
    </div>
  );
});
